import { Link } from "wouter";
import { Badge } from "@/components/ui/badge";
import type { ReferralRow } from "@/hooks/useCois";

/** The attribution chain: every company this person (or firm) introduced. */
export function CoiReferralsTable({ rows, showPerson = false, emptyText }: { rows: ReferralRow[]; showPerson?: boolean; emptyText: string }) {
  if (rows.length === 0) return <p className="text-sm text-muted-foreground italic">{emptyText}</p>;
  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="text-[10px] uppercase tracking-wide text-muted-foreground border-b">
          <th className="text-left py-1.5 pr-2 font-semibold">Company</th>
          {showPerson && <th className="text-left py-1.5 pr-2 font-semibold">Person</th>}
          <th className="text-left py-1.5 pr-2 font-semibold">Introduced</th>
          <th className="text-left py-1.5 pr-2 font-semibold">Stage</th>
          <th className="text-left py-1.5 pr-2 font-semibold">Owner</th>
          <th className="text-left py-1.5 font-semibold">Outcome</th>
        </tr>
      </thead>
      <tbody className="divide-y">
        {rows.map((r) => (
          <tr key={r.companyId}>
            <td className="py-2 pr-2"><Link href={r.category === "Client" ? `/clients/${r.companyId}` : `/prospects/${r.companyId}`} className="font-medium hover:underline">{r.companyName}</Link></td>
            {showPerson && <td className="py-2 pr-2 text-muted-foreground"><Link href={`/coi/${r.personId}`} className="hover:underline">{r.personName}</Link></td>}
            <td className="py-2 pr-2 text-muted-foreground">{r.introducedOn ?? "—"}{r.note && <span className="block text-xs italic truncate max-w-[220px]">“{r.note}”</span>}</td>
            <td className="py-2 pr-2"><Badge className={`text-[10px] ${r.category === "Client" ? "bg-green-700 text-white" : "bg-blue-100 text-blue-700"}`}>{r.category === "Client" ? "Client" : r.status === "On Hold" ? "Nurture" : r.stage ?? "Identified"}</Badge></td>
            <td className="py-2 pr-2 text-muted-foreground">{r.ownerName ?? "—"}</td>
            <td className="py-2 text-muted-foreground">{r.outcome}{r.feeOpportunity ? <span className="text-xs"> · ≈ ${Math.round(r.feeOpportunity / 1000)}K</span> : null}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
